<template>
  <div class="ipadcontainer _ipadcontainer">
  <NavTop :navid = id />
  <div class="home_box">
     <img v-lazy="backimg" alt="" class="julihe_bannerimg">
      <div class="building_box">
        <div class="building_title">{{pname}}</div>
        <div class="building_li" v-for="item in list" :key="item.id" @click="toarticle(item.id)">
         <img v-lazy="item.more.thumbnail" alt="">
         <div class="building_right">
           <div class="building_p">{{item.post_title}}</div>
           <div class="building_text">{{item.post_excerpt}}</div>
         </div>
        </div>
        <van-pagination v-model="currentPage" :page-count="total" mode="simple" @change="paginationchange" />
     </div>
  </div>
  </div>
</template>

<script>
import NavTop from '../comcomponents/NavTop'
import {articleall} from '../../api/jslihe'
import { Pagination } from 'vant'
export default {
  name: '',
  components: {
    NavTop,
    [Pagination.name]: Pagination
  },
  data () {
    return {
      id: Number(this.$route.query.id),
      pname: this.$route.query.name,
      backimg: this.$route.query.img,
      list: [],
      currentPage: 1,
      total: 0
    }
  },
  watch: {
    $route: function (to, from) {
      console.log(to)
      console.log(from)
      if (to.path === from.path) {
        console.log(this.$route.query.id)
        this.id = Number(this.$route.query.id)
        this.pname = this.$route.query.name
        this.backimg = this.$route.query.img
        this.currentPage = 1
        this.getarticlelist()
      }
    }
  },
  mounted () {
    console.log(this.id)
    this.getarticlelist()
  },
  methods: {
    paginationchange (e) {
      console.log(e)
      this.currentPage = e
      this.getarticlelist()
    },
    toarticle (id) {
      this.$router.push({path: 'article', query: {id: id, img: this.backimg}})
    },
    getarticlelist () {
      articleall({category_id: this.id, num: 5, page: this.currentPage}).then(res => {
        console.log(res)
        this.list = res.data.list
        this.total = res.data.pages
      })
    }
  }
}
</script>

<style lang="less" scoped>

// 小于800px
      .building_box{
        padding-left:0.5rem;
        padding-right:0.5rem;
        padding-bottom:5vh;
       .building_title{
         text-align: center;
         font-size:1.2rem;
         color:#333;
         font-weight: bold;
         padding-top:2vh;
         padding-bottom: 2vh;
       }
       .building_li{
         margin-bottom:1rem;
         width:100%;
         display: flex;
         img{
           width:35%;
           height: 6rem;
           margin-right:5%;
           border-radius: 1vw;
         }
         .building_right{
           display: flex;
    flex-flow: column;
    justify-content: space-between;
    width:60%;
     .building_p{
           font-size:0.9rem;
           color:#333;
            white-space: nowrap;
  overflow: hidden;
  text-overflow:ellipsis;
  font-weight: bold;
  text-align: left;
         }
         .building_text{
           text-align: left;
           font-size:0.7rem;
           color:#666666;
 display: -webkit-box;
    overflow: hidden;
    white-space: normal !important;
    text-overflow: ellipsis;
    word-wrap: break-word;
    -webkit-line-clamp: 3;
    /* autoprefixer: ignore next */
-webkit-box-orient: vertical;
         }
         }
       }
      }
</style>



// WEBPACK FOOTER //
// src/components/iPad/iPad.vue